import { render, staticRenderFns } from "./payment_types.vue?vue&type=template&id=a7bf1890&scoped=true&"
import script from "./payment_types.vue?vue&type=script&lang=js&"
export * from "./payment_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bf1890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7bf1890')) {
      api.createRecord('a7bf1890', component.options)
    } else {
      api.reload('a7bf1890', component.options)
    }
    module.hot.accept("./payment_types.vue?vue&type=template&id=a7bf1890&scoped=true&", function () {
      api.rerender('a7bf1890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/payment_types.vue"
export default component.exports